import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { LockOutlined, MailOutlined, ProfileOutlined } from '@ant-design/icons';
import { Button, Form, Input, Alert, Select } from "antd";
import { showAuthMessage, showLoading, hideAuthMessage, authenticated, register, showMessage } from 'redux/features/auth';
import { useHistory } from "react-router-dom";
import { motion } from "framer-motion"
import axios from 'axios';
import jwtDecode from 'jwt-decode'
import { kabupatens } from "constants/DataConstant"


const rules = {
	username: [
		{
			required: true,
			message: 'Please input your email address'
		},
	],
	required: [
		{
			required: true,
			message: 'Data wajib diisi!'
		},
	],
	email: [
		{
			required: true,
			message: 'Please input your email address'
		},
		{
			type: 'email',
			message: 'Please enter a validate email!'
		}
	],
	password: [
		{
			required: true,
			message: 'Please input your password'
		}
	],
	confirm: [
		{
			required: true,
			message: 'Please confirm your password!'
		},
		({ getFieldValue }) => ({
			validator(rule, value) {
				if (!value || getFieldValue('password') === value) {
					return Promise.resolve();
				}
				return Promise.reject('Passwords do not match!');
			},
		})
	]
}

export const RegisterForm = (props) => {
	const dispatch = useDispatch();
	const { showLoading, loading, message, showMessage, showAuthMessage } = props
	const [isSuccess, setIsSuccess] = useState(false)

	const [form] = Form.useForm();
	let history = useHistory();

	const handleValidSubmit = async (values) => {
		showLoading()
		try {
			const credentials = {
				username: values.username,
				email: values.email,
				kabupaten: values.kabupaten,
				role_id: values.role_id || 3,
				password: "1234567890"
			}
			await axios.post('https://api-simkopdes.sumselprov.info/api/v1/auth/register', credentials).then(response => {
				// console.log(response)
				return response
			}).catch(function (error) {
				console.log(error);
			});
			showAuthMessage("Akun berhasil dibuat, hubungi admin!")
			setIsSuccess(true)
		} catch (err) {
			console.log('error:', err)
			showAuthMessage("Error, username or email is already taken!")
			setIsSuccess(false)
		}
	}

	useEffect(() => {
		if (localStorage.getItem('token') !== null) {
			history.push("/app")
		}
	});

	return (
		<>
			<motion.div
				initial={{ opacity: 0, marginBottom: 0 }}
				animate={{
					opacity: showMessage ? 1 : 0,
					marginBottom: showMessage ? 20 : 0
				}}>
				<Alert type="success" message={message}></Alert>
			</motion.div>
			<Form form={form} layout="vertical" name="register-form" onFinish={handleValidSubmit}>
				<Form.Item
					name="username"
					label="Nama Lengkap"
					rules={rules.username}
					hasFeedback
				>
					<Input prefix={<ProfileOutlined className="text-primary" />} />
				</Form.Item>
				<Form.Item
					name="email"
					label="Email"
					rules={rules.email}
					hasFeedback
				>
					<Input prefix={<MailOutlined className="text-primary" />} />
				</Form.Item>
				<Form.Item
					name="role_id"
					label="Pilih Jenis Pengguna Pengguna"
					rules={rules.required}
					hasFeedback
				>
					<Select placeholder="Pilih Jenis Pengguna">
						<Select.Option value={2}>PMO Kab/Kota</Select.Option>
						<Select.Option value={3}>BA Kab/Kota</Select.Option>
						<Select.Option value={4}>Dinas Kab/Kota</Select.Option>
					</Select>
				</Form.Item>
				<Form.Item
					name="kabupaten"
					label="Kabupaten/Kota"
					rules={rules.required}
					hasFeedback
				>
					<Select placeholder="Pilih Kabupaten/Kota">
						{kabupatens.map((kabupaten) => (
							<Select.Option value={kabupaten.value}>{kabupaten.label}</Select.Option>
						))}
					</Select>
				</Form.Item>
				<Form.Item>
					<Button type="primary" style={{ border: "0px" }} htmlType="submit" block loading={loading}>
						Daftar
					</Button>
				</Form.Item>
			</Form>
		</>
	)
}

const mapStateToProps = ({ auth }) => {
	const { loading, message, showMessage, token, redirect } = auth;
	return { loading, message, showMessage, token, redirect }
}

const mapDispatchToProps = {
	showAuthMessage,
	hideAuthMessage,
	showLoading,
	authenticated
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterForm)